namespace Matrix.Administration {
    export interface PermissionSetForm {
        PermissionSetCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        DefaultPermissions: Serenity.TextAreaEditor;
        AssignedToRoles: Serenity.LookupEditor;
        GrantedPermissions: PermissionCheckEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class PermissionSetForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PermissionSet';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PermissionSetForm.init)  {
                PermissionSetForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.LookupEditor;
                var w3 = PermissionCheckEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(PermissionSetForm, [
                    'PermissionSetCode', w0,
                    'Name', w0,
                    'DefaultPermissions', w1,
                    'AssignedToRoles', w2,
                    'GrantedPermissions', w3,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
